import React, { useEffect } from 'react';
import { user } from '../../utils/reactiveVars';
import {
  clearLoginPreferences,
  removeUserFromLocalStorage,
} from '../../utils/user';
import { getSparkyardLoginUrl } from '../../utils/objects';

const Logout = () => {
  useEffect(() => {
    user();
    removeUserFromLocalStorage();
    clearLoginPreferences();
    window.location.href = getSparkyardLoginUrl();
  }, []);

  return <h1>You have been logged out</h1>;
};

export default Logout;
